export const insuranceError = [
  {
    path: '/pagamento-irregular',
    name: 'irregular-insurance',
    component: () => import('@/views/conclusion/GenericServiceDesk.vue'),
    meta: {
      reason: 'irregular health insurance',
      header: {
        title: 'Convênio',
      },
      body: {
        title: 'Continue seu atendimento em um guichê',
        subtitle:
          'não se preocupe, ao chegar na unidade, retire uma senha para continuar seu atendimento.',
        btnLabel: 'Ok, entendi',
        config: {
          showSubtitleArea: true,
        },
      },
    },
  },
];

export const paymentError = [
  {
    path: '/erro-pagamento',
    name: 'payment-error-service-desk',
    component: () => import('@/views/conclusion/GenericServiceDesk.vue'),
    meta: {
      reason: 'payment error',
      header: {
        title: 'Dados de pagamento',
      },
      body: {
        title: 'Ocorreu um problema ao atualizar seus dados de pagamento',
        subtitle:
          'você precisará ser atendido em um guichê, na unidade, retire uma senha para continuar seu atendimento.',
        btnLabel: 'Ok, entendi',
        config: {
          showSubtitleArea: true,
        },
      },
    },
  },
];
